/**
 * @generated SignedSource<<21b9acd5c27b6d130335897d2346da1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header_PossibleImpersonations$data = {
  readonly possibleImpersonations: ReadonlyArray<{
    readonly customerID: number;
    readonly customerName: string;
    readonly roleID: string;
    readonly userID: number;
  }>;
  readonly " $fragmentType": "Header_PossibleImpersonations";
};
export type Header_PossibleImpersonations$key = {
  readonly " $data"?: Header_PossibleImpersonations$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_PossibleImpersonations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_PossibleImpersonations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerToImpersonate",
      "kind": "LinkedField",
      "name": "possibleImpersonations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b2e9d564d9878a9e767d002a43ed410a";

export default node;
